<template>
    <div class="data-model-wrapper">
        <div
            class="data-model"
            :class="{ uploading, filled: value }"
            @click="onClick"
        >
            <input
                hidden
                ref="file"
                type="file"
                @change="onChange"
                multiple
                :accept="accept"
            >

            <div
                v-if="coins"
                class="coins"
            >{{ coins }}</div>

            <div
                v-if="label"
                class="label"
                :class="{ 'hold-place': !value }"
            >{{ label }}<span class="required" v-if="required">&nbsp;&nbsp;*</span></div>

        </div>

        <template
            v-if="multiple && Array.isArray(value)"
        >
            <div
                v-for="(item, i) in value"
                :key="item.id"
                class="doc"
            >
            <span
                    class="close"
                    @click="remove(i)"
            ></span>
                Файл загружен&nbsp;
                <span
                    @click.stop="download(i)"
                >(скачать)</span>
            </div>
        </template>
        <div
            v-else-if="value"
            class="doc"
        >
            <span
                    class="close"
                    @click="remove"
            ></span>
            Файл загружен&nbsp;
            <span
                @click="download"
            >(скачать)</span>
        </div>
    </div>

</template>

<script>
import { post, get } from '../../../tools/http';

import { mapActions } from 'vuex';

const actions = [
    'showPopup',
];

export default {
    name: 'ModelFile',
    props: {
        coins: Number,
        label: String,
        value: [Object, Array],
        multiple: Boolean,
        required: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
            default: '*',
        },
    },
    data() {
        return {
            uploading: false,
            error: {
                success: false,
                title: 'Файл не загружен!',
                text: 'Недопустимые расширение или размер файла',
                button: 'Понятно',
                color: '#D1004A',
            },
            textFromFile: '',
        };
    },
    mounted(){
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    methods: {
        ...mapActions(actions),

        onClick() {
            this.$refs.file.click();
        },

        async onChange() {
            let reader = new FileReader();
            reader.readAsText(this.$refs.file.files[0]);
            reader.onload = (event) => {
                this.textFromFile = event.target.result;
                this.$emit('read-attached-file', this.textFromFile);
            };
            for (const file of this.$refs.file.files) {
                this.uploading = true;

                const res = await post('profile', 'file/upload', { file: file, isPublic: false });

                if (!res) {
                    this.uploading = false;
                    //return this.showPopup(this.error); скрываю модалку (нет в дизайне)
                }

                const bindId = await post('profile', 'file/bind', {
                    'fileId': res.file.id,
                    'group_id': null,
                    'is_favorite': false,
                    'name': `doc${res.file.id}.jpg`,
                }, true);

                if (bindId && bindId.userFile) {
                    if (this.multiple) {
                        const emitValue =
                            Array.isArray(this.value)
                                ? [...this.value, {
                                      id: bindId.userFile.id,
                                      url: res.file.url,
                                }]
                                : [{
                                      id: bindId.userFile.id,
                                      url: res.file.url,
                                }];
                        this.$emit('change', emitValue);
                    } else {
                        this.$emit('change', {
                            id: bindId.userFile.id,
                            url: res.file.url,
                        });
                    }
                } else {
                    console.error('File binding error');
                }
            }
            this.uploading = false;
            this.$refs.file.value = '';
        },
        async download(i = null) {
            let item = this.multiple ? this.value[i] : this.value;
            if (!item) return;
            let url = item.url;
            if (!url) {
                const file = await get('profile', `file/${item.id}`);
                url = file.url;
            }
            if (url) {
                const win = window.open(url, '_blank');
                win.focus();
            }
        },
        remove(i) {
            if (this.multiple) {
                let items = [...this.value];
                items.splice(i, 1);
                this.$emit('change', items);
            } else {
                this.$emit('change', null);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';

.data-model-wrapper {
    margin-top: rem(16);
    margin-bottom: rem(16);
}

.data-model {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: rem(48);
        border: 1px solid #D2D5D9;
    border-radius: rem(10);

    background: no-repeat 1rem/4% url(../../../assets/images/UI/path.svg);
    user-select: none;

    &.uploading {
        pointer-events: none;
            opacity: .5;
    }

    &.filled {
            border-color: #98A0A9;
        //border-radius: rem(10) rem(10) 0 0;
    }

    input {
        position: absolute;
        width: 100%;
        opacity: 0;
    }
}

.label {
    margin-left: rem(56);
    font-style: normal;
    font-weight: normal;
        color: #2A2626;
    font-size: rem(16);
    line-height: rem(24);
    .required {
            color: #D1004A;
    }
}

.doc {
        color: #4663AB;
    font-size: rem(16);
    line-height: rem(24);
    text-decoration-line: underline;

        border: 1px solid #98A0A9;
    border-top-width: 0;
    height: rem(48);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: rem(8);

    span {
        cursor: pointer;

        &:hover {
                color: #5C9CEE;
        }
    }

    &:last-of-type {
        border-radius: 0 0 rem(10) rem(10);
    }
}

.close {
    width: rem(36);
    height: rem(36);
    cursor: pointer;
        background: #fff url(../../../assets/images/cross-red.svg)
        no-repeat center;
    background-size: 50%;
}

    @import "../../../styles/variables";

@media (max-width: $vm) {
    .data-model {
        height: mrem(48);
        background: no-repeat 0.45rem/5% url(../../../assets/images/UI/path.svg);
            border: 1px solid #D2D5D9;
        border-radius: mrem(10);

        &.filled {
                border-color: #98A0A9;
            border-radius: mrem(10) mrem(10) 0 0;
        }

        .label {
            font-size: mrem(16);
            line-height: mrem(24);
            margin-left: mrem(48);
        }

        .label.hold-place {
            color: #98a0a9;
        }
    }
    .doc {
        font-size: mrem(14);
        top: mrem(12);
        left: mrem(40);
        height: mrem(48);

        &:last-of-type {
            border-radius: 0 0 mrem(10) mrem(10);
        }
    }

    .close {
        width: mrem(36);
        height: mrem(36);
    }
}


</style>
